export default __webpack_public_path__ + "static/media/No Added Sugar.d8eec7d5.woff";